import application_settings from '../applicationSettings';
import Event from './Event';

class GetQuantityBasePriceModule extends Event {
    eventName = 'oms_getQuantityBasePriceModule';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get settings
     * 
     * @param {string} data.product_id -  product id given for product
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let productId = data.product_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (productId) {

            // request data
            data.endPoint = application_settings.endPoints.GetQuantityBasePriceModule;
            data.data = {
                product_id: productId,
                client_id: clientId,
                super_attributes: (data.super_attributes) ? data.super_attributes : null,
                order_currency: data.order_currency
            };
        
            this.sendRequest(data, function (response) {
                if (response) {
                    //format response data
                    let data = thisObj.formatResponseData(response);
                    
                    //fire success event
                    thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
                }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "productId is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default GetQuantityBasePriceModule;